import React from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from 'next-intl';
import Router from 'next/router';

import { truncateString } from '../../../helper';

import { ArrowUp } from '../../icons/arrow/arrow';
import CustomLink from '../../atoms/custom-link/customLink';
import StyledBreadcrumb from './breadcrumb.style';

const Breadcrumb = ({ entries, className }) => {
  const t = useTranslations();

  const getBreadCrumbs = () => {
    const buildBreadCrumbs = {};
    return entries
      .map(link => {
        if (buildBreadCrumbs[link.title]) {
          buildBreadCrumbs[link.title] += 1;
        } else {
          buildBreadCrumbs[link.title] = 1;
        }
        return { occurance: buildBreadCrumbs[link.title], ...link };
      })
      .map(link => (
        <li key={link.title} className="breadcrumb__link">
          <CustomLink link={link}>
            {`${
              link.occurance && buildBreadCrumbs[link.title] > 1 ? `${link.occurance}. ` : ''
            }${truncateString(link.title, 30)}`}
          </CustomLink>
        </li>
      ));
  };
  return (
    entries &&
    entries.length > 0 && (
      <StyledBreadcrumb className={className} aria-label="Breadcrumb">
        <ol className="breadcrumb__wrapper">
          {getBreadCrumbs()}
          <li className="breadcrumb__back">
            <button type="button" onClick={() => Router.back()}>
              {t('breadcrumb.back')}
              <ArrowUp />
            </button>
          </li>
        </ol>
      </StyledBreadcrumb>
    )
  );
};

Breadcrumb.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired
  ),
  className: PropTypes.string
};

export default Breadcrumb;
